import { CalendarMonth, DirectionsCar, EventAvailable, Feedback } from "@mui/icons-material";
import { ListSubheader, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { GqlPlannerShiftCompletionStatus } from "~/__generated__";
import GaiaMenuItem from "~/modules/app/components/GaiaMenuItem";

export default function FieldworkerMenu() {
    const { t } = useTranslation("fieldworker");
    return (
        <>
            <ListSubheader sx={{ backgroundColor: "background.default" }}>
                <Typography variant="overline" sx={{ textTransform: "none" }}>
                    {t("fieldworkerMenu.header")}
                </Typography>
            </ListSubheader>

            <GaiaMenuItem to={`/fieldworker/planning`} label={t("fieldworkerMenu.planning")} icon={<CalendarMonth />} />
            <GaiaMenuItem to={`/fieldworker/availability`} label={t("fieldworkerMenu.availability")} icon={<EventAvailable />} />
            <GaiaMenuItem
                to={`/fieldworker/shifts?plannerShiftCompletionStatus=${GqlPlannerShiftCompletionStatus.Approved}`}
                label={t("fieldworkerMenu.shifts")}
                icon={<DirectionsCar />}
                matchExact
            />
            <GaiaMenuItem to={`/fieldworker/feedback`} label={t("fieldworkerMenu.feedback")} icon={<Feedback />} matchExact />
        </>
    );
}
